import React, {createRef, useEffect, useState} from "react";
import FJCustomScroll from "fj-components/FJCustomScroll";

function FJLazyScroll(props) {
  const scrollRef = createRef();
  const {render, classes  , onScroll, itemHeight = 10} = props;
  const [activeList, updateList] = useState([0, 6]);
  const updateUI = () => {
    requestAnimationFrame(() => {
      try {
        let scroll = scrollRef.current.getScroll();
        let scrollTop = scroll.current.getScrollTop();
        let clientHeight = scroll.current.getClientHeight();
        let startIdx = Math.floor(scrollTop / itemHeight);
        let endIdx = Math.ceil((scrollTop + clientHeight) / itemHeight);
        if (activeList[0] !== startIdx || activeList[1] !== endIdx) {
          updateList([startIdx, endIdx]);
        }
      } catch (e) {
        console.log(e);
      }
    })
  };
  const _onScroll = () => {
    updateUI();
    onScroll();
  };
  const _render = () => {
    return render(activeList)
  };
  useEffect(updateUI, []);
  return (
    <FJCustomScroll ref={scrollRef}
                    classes={classes}
                    render={_render}
                    onScroll={_onScroll} />
  );
}

export default FJLazyScroll;